import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { getQuerys, useQuerys } from '@/hooks/useQuery';
export function getRouterUrl(path: string, query?: Record<string, any>, keepQuery = true) {
    const oldHistory = getQuerys();
    return queryString.stringifyUrl(
        {
            url: path,
            query: keepQuery
                ? {
                      ...oldHistory,
                      ...query,
                  }
                : query,
        },
        {
            skipNull: true,
        }
    );
}

export function useRouter() {
    const history = useHistory();

    /**
     * 跳转
     * @param path     路由
     * @param query    查询参数
     * @param keepQuery 是否保留旧的查询参数，默认是true
     */
    function push(path: string, query?: Record<string, any>, keepQuery = true) {
        const keys = Object.keys(query || {});
        keys.forEach(key => {
            if (typeof query[key] === 'object') {
                console.error('stringifyUrl 暂不支持Nesting，可能存在问题，注意检查！', key, query[key]);
            }
        });

        const url = getRouterUrl(path, query, keepQuery);
        history.push(url);
    }
    function replace(path: string, query?: Record<string, any>, keepQuery = true) {
        const url = getRouterUrl(path, query, keepQuery);
        history.replace(url);
    }
    return {
        push,
        replace,
    };
}
